import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        detailList: {},
        openid: '',
        accessToken: '',
        proId: '',
        user: '',//用户信息
        activityName: '',
        permission: [],//权限
        toLogin:false,//是否登录
    },
    mutations: {}
    ,
})

